import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import {
  IconButtonComponent,
  IconComponent,
} from '@totalenergiescode/tds-angular';
import { Asset, TypeNode } from '../../../domain/models';
import { StripPrefixPipe } from '../../pipes/strip-prefix.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, IconButtonComponent, StripPrefixPipe],
  selector: 'lib-type-details',
  standalone: true,
  styleUrl: './type-details.component.scss',
  templateUrl: './type-details.component.html',
})
export class TypeDetailsComponent {
  readonly typeNode = input.required<TypeNode>();
  readonly assets = input<Asset[]>([]);

  readonly close = output<void>();
  readonly navigateToAsset = output<string>();

  readonly relationships = computed(() =>
    this.typeNode()
      .children.filter((c) => c.isRelationshipNode)
      .map((child) => ({
        relationshipType: child.relationshipType!,
        targetAssetType: child.label,
      })),
  );

  onClose(): void {
    this.close.emit();
  }

  onNavigate(assetId: string): void {
    this.navigateToAsset.emit(assetId);
  }
}
